import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingCTAs } from './FloatingCTAs';
import { BottomCTA } from './BottomCTA';
import { CookieConsent } from './CookieConsent';
import { Destinations } from './Destinations';
import { BookingSectionNew } from './BookingSectionNew';

/**
 * ToursPage — kept as a secondary page for customers specifically looking
 * for sightseeing experiences. The Tours section has been removed from the
 * homepage to focus the brand on Premium Private Transfers.
 *
 * Accessible via /:lang/tours (linked in footer only, not in main nav).
 */
export const ToursPage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.title = t('tours_page.seo_title');
  }, [location.pathname, t]);

  return (
    <div className="bg-white">
      <Header />

      <main data-testid="tours-page">
        {/* Slim hero */}
        <section className="relative overflow-hidden bg-[#0a0a0a] pt-28 pb-16 md:pt-36 md:pb-20">
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
              background:
                'radial-gradient(circle at 20% 30%, rgba(245,158,11,0.35), transparent 55%)',
            }}
          />
          <div className="container relative mx-auto max-w-5xl px-6">
            <div className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-amber-400">
              <span className="h-px w-10 bg-amber-500" />
              {t('tours_page.kicker')}
            </div>
            <h1 className="font-serif text-4xl font-bold leading-tight text-white md:text-6xl">
              {t('tours_page.title')}
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
              {t('tours_page.subtitle')}
            </p>
          </div>
        </section>

        {/* Reuse existing Destinations component */}
        <Destinations />

        {/* Booking section */}
        <BookingSectionNew />
      </main>

      <BottomCTA />
      <Footer />
      <FloatingCTAs />
      <CookieConsent />
    </div>
  );
};

export default ToursPage;
